import { render, staticRenderFns } from "./RankingCloseMonthly.vue?vue&type=template&id=2740c200&scoped=true&"
import script from "./RankingCloseMonthly.vue?vue&type=script&lang=js&"
export * from "./RankingCloseMonthly.vue?vue&type=script&lang=js&"
import style0 from "./RankingCloseMonthly.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingCloseMonthly.vue?vue&type=style&index=1&id=2740c200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740c200",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingCloseMonthly.vue"
export default component.exports